"use client"

import * as React from "react"

export type BranchContextOverrideValue = { branchSlug: string; branchId: string }

const BranchContextOverride = React.createContext<BranchContextOverrideValue | null>(null)

/**
 * Overrides the active branch (slug + id) for a subtree. Used by the Branch Details console so the reused
 * feature containers (Members / Ministers / Departments, dashboard, finance) scope to the INSPECTED branch —
 * a branch the parish admin isn't assigned to — while the surrounding app/URL stays in the parish context.
 * Read-only: writes are not expected inside this subtree, and the workspace read-oversight ability authorizes
 * the reads. Contained to the Branch Details tab content, so it never leaks into the sidebar/nav.
 */
export function BranchContextOverrideProvider({
  branchSlug,
  branchId,
  children,
}: BranchContextOverrideValue & { children: React.ReactNode }) {
  const value = React.useMemo(() => ({ branchSlug, branchId }), [branchSlug, branchId])
  return <BranchContextOverride.Provider value={value}>{children}</BranchContextOverride.Provider>
}

export function useBranchContextOverride(): BranchContextOverrideValue | null {
  return React.useContext(BranchContextOverride)
}
